import { useEffect, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { REACT_APP_BRANCH_PREFIX } from 'utils/constants/environment'
import { useIsMobile } from 'utils/hooks/useIsMobile'
import VolunteerLeftSideBar from './VolunteerLeftSideBar'

/** Public volunteer check-in shell (logo-only sidebar). Detect via `isStaticModePath()`. */
export default function VolunteerLayout({ children }: { children: ReactNode }) {
  const isMobile = useIsMobile()
  const location = useLocation()
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false)

  useEffect(() => {
    if (!isMobile) setMobileDrawerVisible(false)
  }, [isMobile])

  useEffect(() => {
    setMobileDrawerVisible(false)
  }, [location.pathname])

  return (
    <div className="w-full h-full flex bg-gray-100 gap-3 min-h-screen">
      {!isMobile ? <VolunteerLeftSideBar /> : null}
      {isMobile ? (
        <>
          <div
            className={
              mobileDrawerVisible
                ? 'mobile-drawer-overlay open'
                : 'mobile-drawer-overlay'
            }
            style={{ zIndex: 1099 }}
            onClick={() => setMobileDrawerVisible(false)}
          />
          <div
            className={
              mobileDrawerVisible
                ? 'mobile-drawer-panel open'
                : 'mobile-drawer-panel'
            }
            style={{ zIndex: 1100 }}
          >
            <VolunteerLeftSideBar onClose={() => setMobileDrawerVisible(false)} />
          </div>
        </>
      ) : null}
      <div className="flex-1 md:pr-3 overflow-hidden min-w-0">
        {isMobile ? (
          <div className="card border-round-xl px-3 py-2 mb-2 mx-2 mt-2 flex align-items-center justify-content-between">
            <img
              src={
                window.location.origin.includes(REACT_APP_BRANCH_PREFIX)
                  ? '/images/logo-branch.svg'
                  : '/images/logo-app.svg'
              }
              alt="logo"
              className="w-6rem"
            />
            <button
              type="button"
              className="p-2 border-none bg-transparent cursor-pointer"
              onClick={() => setMobileDrawerVisible(true)}
              aria-label="Menu"
            >
              <i className="isax isax-menu text-xl" />
            </button>
          </div>
        ) : null}
        {children}
      </div>
    </div>
  )
}
